import api from "@/api/api-basic";
import api1 from "@/api/api-v1-config";


export async function getUserPermissionsAxios() {    
    return await api.get("personal/permissions");
}

export async function changePasswordAxios(data) {    
    return await api1.put("personal/change-password",data);
}

